import * as React from 'react';
import { default as MuiBox, BoxProps } from '@material-ui/core/Box';

export const Box = (props: BoxProps) => <MuiBox {...props} />;

export default Box;
